import {
	useTheme,
	TextCompat as Text,
	StackCompat as Stack,
} from 'components/FluentUICompat';
import {useUserContext} from 'authentication/UserContext';
import {useTranslation} from 'react-i18next';
import {
	BaseWorkBenchComponent,
	getDashboardClassNames,
	MyRecentActivity,
} from './components/Common/BaseWorkBenchComponent';
import React, {useState} from 'react';
import VkoWorkbenchComponent from './components/VkoWorkbench/VkoWorkbenchComponent';
import {WorkbenchBaselineList} from './components/BedarfsWorkbench/WorkbenchBaselineList';
import {BedarfsWorkbenchSection} from './components/BedarfsWorkbench/BedarfsWorkbenchSection';
import VkoApproverWorkbenchComponent from './components/VkoApproverWorkbench/VkoApproverWorkbenchComponent';
import {MyReviewItems} from './components/ApproverWorkbench/MyReviewItems';
import {DashboardPageVexPart} from './DashboardPageVexPart';

const DashboardPageV2 = () => {
	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'DashboardPage',
	});
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	const {isAdmin, isReader, isVex, isVko, isApprover, isBedarfskoordinator} =
		useUserContext();

	const [approverReviewCount, setApproverReviewCount] = useState<
		number | undefined
	>(undefined);
	const [activityItemCount, setActivityItemCount] = useState<
		number | undefined
	>(undefined);
	const renderBedarfsWorkbenchLists = () => (
		<WorkbenchBaselineList halfHeight />
	);

	return (
		<div style={{background: theme.palette.neutralLight}}>
			{isVko &&
				(isApprover ? (
					<VkoApproverWorkbenchComponent />
				) : (
					<VkoWorkbenchComponent />
				))}
			<DashboardPageVexPart />
			{(isAdmin || isReader || isVko || (!isVko && !isVex && isApprover)) && (
				<BaseWorkBenchComponent />
			)}
			{!isVko && !isVex && isApprover && (
				<>
					<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
						<Text className={classNames.WorkbenchHeaderText}>
							{t('ApproverOveriewHeader')}
						</Text>
					</Stack>
					<Stack
						horizontal
						horizontalAlign='start'
						styles={{root: {width: '100%'}}}
						grow={1}
					>
						<MyReviewItems
							halfHeight
							itemCountLoaded={(count: number) => setApproverReviewCount(count)}
						/>
					</Stack>
				</>
			)}
			{isBedarfskoordinator && (
				<BedarfsWorkbenchSection
					renderBedarfsWorkbenchLists={renderBedarfsWorkbenchLists}
					t={t}
				/>
			)}
			{isVex && (
				<MyRecentActivity
					itemCountLoaded={(count: number) => setActivityItemCount(count)}
				/>
			)}
		</div>
	);
};

export default DashboardPageV2;
